export function isImage(path: string) {
  const imageTypes = ["jpg", "jpeg", "png", "gif", "svg", "webp"];
  return hasExtension(path, imageTypes);
}

export function hasExtension(path: string, extensions: string[]) {
  let fileExtension = /[^.]+$/.exec(path)[0];

  return typeof fileExtension !== "undefined"
    ? extensions
        .map((extension) => extension.toLowerCase())
        .includes(fileExtension.toLowerCase())
    : false;
}
